export default function getFileName(path) {
    const filename = path.replace(/\.[^/.]+$/, "");
    return filename;
}
